export default __webpack_public_path__ + "static/media/address_example.c8b8bd55.pdf";